<template>
  <span>
        <a v-on:click="putItem" 
          type="submit" 
          class="inline-block no-underline font-bold text-sm bg-gray-100 text-green-700 border border-green-700 commitbutton mt-1 rounded px-5 py-3 hover:text-white hover:bg-green-700 cursor-pointer"
          :class="{ 'loading': submitting }"
        >
          <i aria-hidden="true" class="material-icons align-middle text-xl">{{buttonicon}}</i>
          {{ buttonname }}
        </a>
    </span>
</template>

<script>
import axios from 'axios'

  export default {

        props: {
            content: '',
            route:'',
            routeparam:'',
            redirectlink:'',
            buttontarget: {
              default: '_self'
            },
            buttonname: {
              default: 'Confirm',
            },
            buttonicon: {
              default: 'check',
            },
            buttonsize: {
              default: 'text-xs',
            },
            value: {
              default: 0,
            },
        },

        data() {
          return {
            isHidden: true,
            submitting: false,
            errors: [],
            loaded: true,
          }
        },
        
        methods: {

          putItem: function (event) {
            let url = this.redirectlink;
            if (! this.submitting) {
              this.submitting = true;
              this.errors = [];
              axios.put(this.route,
                { [this.routeparam]: this.value }
              )
              .then(() => {
                window.location.href = url;
              })
              .catch((errors) => {
                this.submitting = false;
                this.errors = errors.response?.data?.errors?.[this.routeparam] || [];
              })
            };
          }

        },
      }
</script>
